// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"462":"3a200752a1ffa447","888":"06973cc5decbc287"}[chunkId] + ".css";
};